// extracted by mini-css-extract-plugin
export default {"ourWork":"OurWork_ourWork__X4WIi","list":"OurWork_list__-BSXz","item":"OurWork_item__cCvKi","btn":"OurWork_btn__w9GQG"};